import { render } from "./TextHeadlinePrimary.vue?vue&type=template&id=47260bbc&scoped=true"
const script = {}

import "./TextHeadlinePrimary.vue?vue&type=style&index=0&id=47260bbc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47260bbc"]])

export default __exports__